"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const dnaR_timePicker_model_1 = require("./dnaR-timePicker.model");
const i0 = require("@angular/core");
const i1 = require("@angular/common");
const i2 = require("./dnaR-timePicker-click-outside.directive");
const i3 = require("@angular/forms");
function DnaRTimePicker_label_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function DnaRTimePicker_label_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r5.info);
} }
function DnaRTimePicker_label_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtemplate(1, DnaRTimePicker_label_0_span_1_Template, 2, 0, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, DnaRTimePicker_label_0_span_3_Template, 1, 1, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.info);
} }
function DnaRTimePicker_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵlistener("click", function DnaRTimePicker_span_5_Template_span_click_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r6.onClearSelectedItems(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "is-selected-item": a0 }; };
function DnaRTimePicker_div_8_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 18, 19);
    i0.ɵɵlistener("click", function DnaRTimePicker_div_8_li_2_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r13); const value_r9 = ctx.$implicit; const ctx_r12 = i0.ɵɵnextContext(2); $event.stopPropagation(); return ctx_r12.onItemClick(value_r9); });
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r9 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "item-", value_r9.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx_r8.isSelected(value_r9, true)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(value_r9.text);
} }
function DnaRTimePicker_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, DnaRTimePicker_div_8_li_2_Template, 4, 5, "li", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r2.defaultOpen);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.timePickerValues);
} }
function DnaRTimePicker_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.helperText);
} }
const _c1 = function (a0, a1) { return { "disabled": a0, "invalid": a1 }; };
exports.TIMEPICKER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(() => DnaRTimePicker),
    multi: true
};
const noop = () => { };
class DnaRTimePicker {
    constructor(elRef) {
        this.elRef = elRef;
        this.timePickerValues = [];
        this.showError = false;
        this.is24HoursFormat = false;
        this.timeInterval = 30;
        this.defaultOpen = false;
        this.isDisabled = false;
        this.isRequired = false;
        this.formSubmitted = false;
        this.onDropDownClose = new core_1.EventEmitter();
        this.onSelect = new core_1.EventEmitter();
        this.onDeSelect = new core_1.EventEmitter();
        this.onTouchedEvent = new core_1.EventEmitter();
        this.onSelectionChange = new core_1.EventEmitter();
        this.onTouchedCallback = () => { this.onTouchedEvent.emit(true); };
        this.onChangeCallback = noop;
    }
    ngOnInit() {
        this.timePickerValues = this.generateTimeValues();
        if (this.time) {
            this.formatTime(this.time);
        }
    }
    // Handle alt down arrow keys and escape key press
    handleAltDownUpEscape(event) {
        if (event.key === 'ArrowDown' && event.altKey) {
            event.preventDefault();
            this.defaultOpen = true;
        }
        if (event.key === 'ArrowUp' && event.altKey) {
            event.preventDefault();
            this.closeTimePicker();
        }
        if (event.key === 'Escape') {
            this.onClearSelectedItems();
            this.closeTimePicker();
        }
        this.showError = this.isRequired && !this.time && !this.selectedItem;
    }
    // Handle item click
    onItemClick(item) {
        if (this.isDisabled) {
            return false;
        }
        this.onTouchedCallback();
        const found = this.isSelected(item);
        if (!found) {
            this.addSelected(item, true);
        }
        else {
            this.removeSelected(item);
        }
        this.closeTimePicker();
        this.showError = this.isRequired && !this.time && !this.selectedItem;
    }
    // Handle clear selected items
    onClearSelectedItems() {
        if (this.isDisabled) {
            return false;
        }
        this.onTouchedCallback();
        this.selectedItem = null;
        this.time = '';
        this.onChangeCallback(this.emittedValue(this.selectedItem));
        this.onSelectionChange.emit(this.selectedItem);
        this.showError = this.isRequired && !this.time && !this.selectedItem;
    }
    // Write value
    writeValue(value) {
        setTimeout(() => {
            if (value !== undefined && value !== null && value.length > 0) {
                try {
                    if (value.length >= 1) {
                        this.formatTime(value);
                        const firstItem = value[0];
                        this.selectedItem =
                            typeof firstItem === 'string'
                                ? new dnaR_timePicker_model_1.ListItem(firstItem)
                                : new dnaR_timePicker_model_1.ListItem({
                                    id: firstItem["id"],
                                    text: firstItem["text"]
                                });
                    }
                }
                catch (e) {
                    console.error(e.body.msg);
                }
            }
            else if (value !== undefined && value !== null && ((value.length === undefined || value.length === 0))) {
                this.selectedItem = null;
            }
        });
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    onTouched() {
        this.closeTimePicker();
        this.onTouchedCallback();
    }
    trackByFn(index, item) {
        return item.id;
    }
    // Check if item is selected
    isSelected(clickedItem) {
        var _a;
        let found = false;
        if (this.selectedItem !== undefined && clickedItem !== undefined && clickedItem.id === ((_a = this.selectedItem) === null || _a === void 0 ? void 0 : _a.id)) {
            found = true;
        }
        return found;
    }
    addSelected(item, notify = false) {
        this.selectedItem = item;
        this.time = this.selectedItem.text;
        this.formatTime(this.selectedItem.text);
        if (notify) {
            this.onChangeCallback(this.emittedValue(this.selectedItem));
            this.onSelect.emit(this.emittedValue(item));
            this.onSelectionChange.emit(this.selectedItem);
        }
    }
    removeSelected(itemSel) {
        this.selectedItem = null;
        this.time = '';
        this.onChangeCallback(this.emittedValue(this.selectedItem));
        this.onDeSelect.emit(this.emittedValue(itemSel));
        this.onSelectionChange.emit(this.selectedItem);
    }
    emittedValue(val) {
        const selected = [];
        if (Array.isArray(val)) {
            val.map(item => {
                if (item.id === item.text) {
                    selected.push(item.text);
                }
                else {
                    selected.push(this.objectify(item));
                }
            });
        }
        else {
            if (val) {
                if (val.id === val.text) {
                    return val.text;
                }
                else {
                    return this.objectify(val);
                }
            }
        }
        return selected;
    }
    objectify(val) {
        const obj = {};
        obj["id"] = val.id;
        obj["text"] = val.text;
        return obj;
    }
    // Toggle time picker
    toggleTimePicker(evt) {
        evt.preventDefault();
        if (this.isDisabled) {
            return;
        }
        this.defaultOpen = !this.defaultOpen;
        if (!this.defaultOpen) {
            this.onTouchedCallback();
            this.onDropDownClose.emit();
        }
        this.showHideDropdowns(evt);
    }
    // Show hide dropdowns
    showHideDropdowns(evt) {
        var _a, _b, _c, _d;
        const dropdowns = document.getElementsByClassName('dropdown-list');
        Array.from(dropdowns).map(x => x.classList.add('hide'));
        const children = Array.from((_d = (_c = (_b = (_a = evt === null || evt === void 0 ? void 0 : evt.currentTarget) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.children);
        children.forEach((child) => {
            if (child['classList'].contains('dropdown-list')) {
                child['classList'].remove('hide');
            }
        });
    }
    closeTimePicker() {
        if (this.defaultOpen) {
            this.onTouchedCallback();
        }
        this.defaultOpen = false;
        this.onDropDownClose.emit();
    }
    // Generate time picker values
    generateTimeValues() {
        const timeValues = [];
        for (let hours = 0; hours < 24; hours++) {
            for (let minutes = 0; minutes < 60; minutes += this.timeInterval) {
                const minutesValue = minutes === 0 ? '00' : minutes.toString().padStart(2, '0');
                let timeValue = '';
                if (!this.is24HoursFormat) {
                    const hoursSuffix = hours >= 0 && hours < 12 ? 'AM' : 'PM';
                    const hoursValue = (hours === 0 || hours === 12) ? 12 : hours > 12 ? hours - 12 : hours;
                    timeValue = `${hoursValue}:${minutesValue} ${hoursSuffix}`;
                }
                else {
                    const hoursValue = hours === 0 ? '00' : hours.toString().padStart(2, '0');
                    timeValue = `${hoursValue}:${minutesValue}`;
                }
                timeValues.push(timeValue);
            }
        }
        return timeValues.map(x => new dnaR_timePicker_model_1.ListItem(x));
    }
    inputChanged($event) {
        this.time = $event.target.value;
        this.showError = this.isRequired && !this.time && !this.selectedItem;
        this.onChangeCallback($event.target.value);
        this.onTouchedCallback();
    }
    formatTime(time) {
        var _a;
        let hours = parseInt(time.split(':')[0]);
        let minutes = time.split(':')[1] ? parseInt(time.split(':')[1]) : '00';
        let timePeriod = time.split(' ')[1] ? time.split(' ')[1] : '';
        if (hours == 12) {
            hours = timePeriod == 'AM' ? 0 : hours;
        }
        else if (timePeriod == 'PM') {
            hours = hours + 12;
        }
        this.time = `${hours.toString().padStart(2, '0')}:${(_a = minutes.toString()) === null || _a === void 0 ? void 0 : _a.padStart(2, '0')}`.trim();
    }
}
exports.DnaRTimePicker = DnaRTimePicker;
DnaRTimePicker.ɵfac = function DnaRTimePicker_Factory(t) { return new (t || DnaRTimePicker)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
DnaRTimePicker.ɵcmp = i0.ɵɵdefineComponent({ type: DnaRTimePicker, selectors: [["dnaR-time-picker"]], hostBindings: function DnaRTimePicker_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("blur", function DnaRTimePicker_blur_HostBindingHandler() { return ctx.onTouched(); });
    } }, inputs: { label: "label", info: "info", helperText: "helperText", is24HoursFormat: "is24HoursFormat", timeInterval: "timeInterval", defaultOpen: "defaultOpen", isDisabled: "isDisabled", isRequired: "isRequired", formSubmitted: "formSubmitted" }, outputs: { onDropDownClose: "onDropDownClose", onSelect: "onSelect", onDeSelect: "onDeSelect", onTouchedEvent: "onTouchedEvent", onSelectionChange: "onSelectionChange" }, features: [i0.ɵɵProvidersFeature([exports.TIMEPICKER_CONTROL_VALUE_ACCESSOR])], decls: 10, vars: 14, consts: [["class", "time-picker-label", 4, "ngIf"], ["tabindex", "=0", 1, "time-picker", 3, "blur", "clickOutside"], ["tabindex", "-1", 1, "dnaRComponent", "dropdown-btn", 3, "ngClass"], ["type", "time", "id", "timePicker", 1, "input", 3, "ngModel", "disabled", "required", "ngClass", "ngModelChange", "keyup", "change", "blur", "keydown"], ["class", "selected-items-clear", 4, "ngIf"], [1, "toggle-time", 3, "click"], [1, "icon", "icon-time-outline", "icon-color"], ["class", "dropdown-list", 3, "hidden", 4, "ngIf"], ["class", "helper-text", 4, "ngIf"], [1, "time-picker-label"], ["class", "required", 4, "ngIf"], ["class", "icon icon-info-fill info", 3, "title", 4, "ngIf"], [1, "required"], [1, "icon", "icon-info-fill", "info", 3, "title"], [1, "selected-items-clear"], [1, "icon", "icon-cancel-fill", "icon-color", 3, "click"], [1, "dropdown-list", 3, "hidden"], ["class", "time-picker-option", 3, "id", "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "time-picker-option", 3, "id", "ngClass", "click"], ["item", ""], ["id", "itemText"], [1, "helper-text"]], template: function DnaRTimePicker_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DnaRTimePicker_label_0_Template, 4, 3, "label", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("blur", function DnaRTimePicker_Template_div_blur_1_listener() { return ctx.onTouched(); })("clickOutside", function DnaRTimePicker_Template_div_clickOutside_1_listener() { return ctx.closeTimePicker(); });
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵelementStart(3, "span", 2);
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("ngModelChange", function DnaRTimePicker_Template_input_ngModelChange_4_listener($event) { return ctx.time = $event; })("keyup", function DnaRTimePicker_Template_input_keyup_4_listener($event) { return ctx.inputChanged($event); })("change", function DnaRTimePicker_Template_input_change_4_listener($event) { return ctx.inputChanged($event); })("blur", function DnaRTimePicker_Template_input_blur_4_listener() { return ctx.onTouchedCallback(); })("keydown", function DnaRTimePicker_Template_input_keydown_4_listener($event) { $event.stopPropagation(); return ctx.handleAltDownUpEscape($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, DnaRTimePicker_span_5_Template, 2, 0, "span", 4);
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵlistener("click", function DnaRTimePicker_Template_span_click_6_listener($event) { $event.stopPropagation(); return ctx.toggleTimePicker($event); });
        i0.ɵɵelement(7, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, DnaRTimePicker_div_8_Template, 3, 2, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, DnaRTimePicker_p_9_Template, 2, 1, "p", 8);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.label);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("disabled", ctx.isDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.defaultOpen ? "infocus" : "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.time)("disabled", ctx.isDisabled)("required", ctx.isRequired)("ngClass", i0.ɵɵpureFunction2(11, _c1, ctx.isDisabled, ctx.formSubmitted && ctx.isRequired && (ctx.time == "" || !ctx.time) && !ctx.selectedItem));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.time && !ctx.isDisabled);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.helperText && !ctx.isDisabled && (ctx.formSubmitted && ctx.isRequired && (ctx.time == "" || !ctx.time) && !ctx.selectedItem || ctx.showError));
    } }, directives: [i1.NgIf, i2.ClickOutsideDirective, i1.NgClass, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, i3.RequiredValidator, i1.NgForOf], styles: [".dnaRComponent[_ngcontent-%COMP%] {\n  display: inline-block;\n  border-radius: 2px;\n  float: left;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n.dnaRComponent[_ngcontent-%COMP%]:focus:not(.invalid), .input[_ngcontent-%COMP%]:focus:not(.invalid) {\n  border: 1px solid #008381 !important;\n  outline: none;\n}\n.valid[_ngcontent-%COMP%] {\n  border-color: #AAAAAA;\n}\n.invalid[_ngcontent-%COMP%] {\n  border-color: #C53535 !important;\n  outline: none;\n}\n.time-picker[_ngcontent-%COMP%] {\n  position: relative;\n  height: 34px;\n  font-size: 16px;\n  font-family: inherit;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%] {\n  display: flex;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%] {\n  border: 1px solid #AAAAAA;\n  width: 100%;\n  position: absolute;\n  height: 34px;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: left;\n  vertical-align: middle;\n  cursor: pointer;\n  background-image: none;\n  border-radius: 2px;\n  padding: 5px;\n  color: #414141;\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-size: 16px;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]::selection {\n  color: #ffffff;\n  background-color: #008381;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:focus-visible:hover    ~ .selected-items-clear[_ngcontent-%COMP%] {\n  height: 30px;\n  top: 2px;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input.ng-touched.ng-invalid[_ngcontent-%COMP%] {\n  border: 1px solid #C53535;\n  outline: none;\n  box-shadow: none;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input.invalid[_ngcontent-%COMP%] {\n  border: 1px solid #C53535;\n  outline: none;\n  box-shadow: none;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input.warning[_ngcontent-%COMP%] {\n  border: 1px solid #F5A623;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input.disabled[_ngcontent-%COMP%] {\n  background-color: #F5F5F5;\n  border: 1px solid #D2D2D2;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input.disabled[_ngcontent-%COMP%]:hover {\n  background-color: #F5F5F5;\n  border: 1px solid #D2D2D2 !important;\n  cursor: default;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%] {\n  border: 1px solid #337ab7;\n  margin-right: 4px;\n  background: #337ab7;\n  padding: 0px 5px;\n  color: #ffffff;\n  border-radius: 2px;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  text-decoration: none;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-items-clear[_ngcontent-%COMP%] {\n  top: 1px;\n  padding: 5px;\n  height: 32px;\n  position: absolute;\n  right: 31px;\n  border-right: 1px solid #D2D2D2;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-items-clear[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%] {\n  width: 24px;\n  height: 24px;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .icon-color[_ngcontent-%COMP%] {\n  background-color: #949494 !important;\n  cursor: pointer;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .toggle-time[_ngcontent-%COMP%] {\n  position: absolute;\n  right: 0px;\n  padding: 5px;\n  height: 34px;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .toggle-time[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%] {\n  height: 24px;\n  width: 24px;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]:active:not(:invalid), .time-picker[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:active:not(:invalid) {\n  border: 1px solid #008381 !important;\n  background-color: #ffffff;\n}\n.time-picker[_ngcontent-%COMP%]   .dropdown-btn.infocus[_ngcontent-%COMP%] {\n  border-color: #008381;\n}\n.time-picker[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  background-color: #F5F5F5;\n}\n.dropdown-list[_ngcontent-%COMP%]:not(.hide) {\n  position: absolute;\n  top: 34px;\n  z-index: 9999;\n  border: 1px solid #ccc;\n  background: #ffffff;\n  box-shadow: 0px 1px 5px #959595;\n}\n.dropdown-list[_ngcontent-%COMP%]:not(.hide)   ul[_ngcontent-%COMP%] {\n  padding: 0px;\n  list-style: none;\n  overflow: auto;\n  margin: 0px;\n  height: 197px;\n}\n.dropdown-list[_ngcontent-%COMP%]:not(.hide)   li[_ngcontent-%COMP%] {\n  padding: 8px 16px;\n  cursor: pointer;\n  text-align: left;\n  line-height: 24px;\n}\n.dropdown-list[_ngcontent-%COMP%]:not(.hide)   .item-header[_ngcontent-%COMP%] {\n  font-weight: 600;\n}\n.dropdown-list[_ngcontent-%COMP%]:not(.hide)   li.time-picker-option[_ngcontent-%COMP%]:hover {\n  background: #008381;\n}\n.dropdown-list[_ngcontent-%COMP%]:not(.hide)   li.time-picker-option[_ngcontent-%COMP%]:hover   #itemText[_ngcontent-%COMP%] {\n  text-decoration: none;\n  color: #ffffff !important;\n}\n.time-picker-option.is-selected-item[_ngcontent-%COMP%]   #itemText[_ngcontent-%COMP%] {\n  color: #008381;\n  font-weight: 600;\n}\n@keyframes borderscale {\n  50% {\n    box-shadow: 0 0 0 2px #337ab7;\n  }\n}\n.li-disabled[_ngcontent-%COMP%] {\n  pointer-events: none;\n  opacity: 0.6;\n}\n.dropdown-list.hide[_ngcontent-%COMP%] {\n  display: none;\n}\n.helper-text[_ngcontent-%COMP%] {\n  font-size: 12px;\n  color: #C53535;\n  padding-left: 2px;\n  padding-top: 4px;\n}\ninput[type=\"time\"][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator {\n  opacity: 0;\n}\ninput[type=\"time\"][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=\"time\"][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator {\n  display: none;\n}\ninput[type=\"time\"][_ngcontent-%COMP%] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\ninput[type=\"time\"][_ngcontent-%COMP%]:invalid:before, input[type=\"time\"][_ngcontent-%COMP%]:disabled:before {\n  content: 'HH:MM';\n  color: #757575;\n  position: absolute;\n  background: #F5F5F5;\n}\ninput[type=\"time\"][_ngcontent-%COMP%]:disabled:before {\n  background: #F5F5F5;\n}\ninput[type=\"time\"][_ngcontent-%COMP%]:invalid:before {\n  background: #ffffff;\n}\ninput[type=\"time\"][_ngcontent-%COMP%]:focus:before {\n  width: 0;\n  content: '';\n}\ninput[type=time][_ngcontent-%COMP%]::-webkit-datetime-edit-hour-field:focus, input[type=time][_ngcontent-%COMP%]::-webkit-datetime-edit-minute-field:focus, input[type=time][_ngcontent-%COMP%]::-webkit-datetime-edit-second-field:focus, input[type=time][_ngcontent-%COMP%]::-webkit-datetime-edit-ampm-field:focus {\n  color: #ffffff;\n  background-color: #008381 !important;\n}\ninput[type=time][_ngcontent-%COMP%]::-webkit-datetime-edit-hour-field {\n  margin-left: 3px;\n}\ninput[type=time][_ngcontent-%COMP%]::-webkit-datetime-edit-minute-field {\n  margin-right: 2px;\n}\n.time-picker-label[_ngcontent-%COMP%] {\n  line-height: 20px;\n  font-weight: 400;\n  color: #414141;\n}\n.time-picker-label[_ngcontent-%COMP%]   .required[_ngcontent-%COMP%] {\n  padding-right: 2px;\n}\n.required[_ngcontent-%COMP%] {\n  color: #C53535;\n}\n.info[_ngcontent-%COMP%] {\n  height: 16px;\n  width: 16px;\n  background-color: #757575;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DnaRTimePicker, [{
        type: core_1.Component,
        args: [{
                selector: 'dnaR-time-picker',
                templateUrl: './dnaR-timePicker.component.html',
                styleUrls: ['./dnaR-timePicker.component.less'],
                providers: [exports.TIMEPICKER_CONTROL_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { label: [{
            type: core_1.Input
        }], info: [{
            type: core_1.Input
        }], helperText: [{
            type: core_1.Input
        }], is24HoursFormat: [{
            type: core_1.Input
        }], timeInterval: [{
            type: core_1.Input
        }], defaultOpen: [{
            type: core_1.Input
        }], isDisabled: [{
            type: core_1.Input
        }], isRequired: [{
            type: core_1.Input
        }], formSubmitted: [{
            type: core_1.Input
        }], onDropDownClose: [{
            type: core_1.Output
        }], onSelect: [{
            type: core_1.Output
        }], onDeSelect: [{
            type: core_1.Output
        }], onTouchedEvent: [{
            type: core_1.Output
        }], onSelectionChange: [{
            type: core_1.Output
        }], onTouched: [{
            type: core_1.HostListener,
            args: ['blur']
        }] }); })();
